import z from 'zod';

import { ErrorMap } from '@anyx/shared-utils';

import { AnyChatErrorCode } from './constants';

const errorExtensionSchema = z.object({
  extensions: z.object({
    message: z.string(),
  }),
});

const errorCodeSchema = z
  .object({
    errors: z.array(errorExtensionSchema).nonempty(),
  })
  .transform((obj) => obj.errors[0].extensions.message);

export function isSupportedAnyChatErrorCode(
  code: string,
  errorMap: {
    readonly [K: string]: string;
  }
) {
  return !!errorMap[code];
}

/**
 * use to extract error code from ApolloError
 */
export function getAnyChatErrorCode<ErrorCode extends string = AnyChatErrorCode>(
  error: unknown,
  errorMap?: ErrorMap<ErrorCode>
) {
  try {
    const code = errorCodeSchema.parse(error);
    const isSupported = isSupportedAnyChatErrorCode(code, errorMap || AnyChatErrorCode);

    if (!isSupported) return undefined;

    return code as ErrorCode;
  } catch (err) {
    return undefined;
  }
}
